import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TVitrinaConfig } from 'shared/types/TVitrinsService';

const initialState: { config: TVitrinaConfig | null } = {
  config: null,
};

export const vitrinsConfigSlice = createSlice({
  name: 'vitrinsConfig',
  initialState,
  reducers: {
    setVitrinsConfig: (_, { payload }: PayloadAction<TVitrinaConfig>) => ({
      config: payload,
    }),
  },
});

export const { setVitrinsConfig } = vitrinsConfigSlice.actions;
